import HeaderBase from './components/cells/HeaderBase';

export default function HeaderBlankCell() {}

HeaderBlankCell.prototype.init = function (params) {
    this.eGui = HeaderBase(document.createElement('div'), {
        ...params,
        enableSorting: false,
    });
};

HeaderBlankCell.prototype.getGui = function () {
    return this.eGui;
};
